export const waitForElement = (selector: string, callback: () => void, interval = 500) => {
  const checkElement = () => {
    if (document.querySelector(selector)) {
      callback();
    } else {
      setTimeout(checkElement, interval);
    }
  };
  checkElement();
};

export const observeDOMForElement = (selector: string, callback: (element: HTMLElement) => void) => {
  let element = document.querySelector(selector) as HTMLElement;

  if (element) {
    callback(element);
    return;
  }

  const observer = new MutationObserver(() => {
    element = document.querySelector(selector) as HTMLElement;
    if (element) {
      callback(element);
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  return observer;
};
